import update from 'immutability-helper';

import { SET_FEEDBACK_LIST, SET_FEEDBACK_TOTAL_COUNT, SET_FEEDBACK_SORT_BY } from './constants';

export default function (state = {}, action) {
  switch (action.type) {
    case SET_FEEDBACK_LIST: {
      const { list } = action;
      return update(state, {
        list: { $set: list },
      });
    }
    case SET_FEEDBACK_TOTAL_COUNT: {
      const { count } = action;
      return update(state, {
        count: { $set: count },
      });
    }
    case SET_FEEDBACK_SORT_BY: {
      const { value } = action;
      return update(state, {
        sortBy: { $set: value },
        list: { $set: [] },
      });
    }
    default:
      return state;
  }
}
